import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBAbLjlqJ6To2Pq22hm5EONuL8P3w7cvMA",
  authDomain: "after10m-5b0ae.firebaseapp.com",
  databaseURL: "https://after10m-5b0ae.firebaseio.com",
  projectId: "after10m-5b0ae",
  storageBucket: "after10m-5b0ae.firebasestorage.app",
  messagingSenderId: "632650626589",
  appId: "1:632650626589:web:649c5e9fd774b66456b8f4",
  measurementId: "G-08GLMRHXLJ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
